<template>
  <div class="insertNewFlowNode">
    <el-drawer
      :visible.sync="drawerVisible"
      direction="rtl"
      @open="open"
      :before-close="handleClose"
      @closed="closed"
      :modal="false"
      append-to-body
      custom-class="drawer-insertNode"
      size="600"
    >
      <div slot="title" class="titleContianer">
        <div class="title">
          <div v-if="detailVisible" class="icon-back" @click="hideDetail">
            <i class="el-icon-back"></i>
          </div>
          {{ header }}
        </div>
      </div>
      <div v-if="!detailVisible" class="content">
        <div v-for="(listInfo, listIndex) in filterType" :key="listIndex">
          <div class="listTitle">{{ listInfo.title }}</div>
          <ul class="nodeList">
            <li v-for="(item, index) in listInfo.list" :key="index" @click="insertFlowNode(item)">
              <span class="nodeIcon" :class="item.class">
                <svg-icon :icon-class="item.icon"></svg-icon>
                <!--<i :class="item.icon"></i>-->
              </span>
              <div class="nodeName">{{ item.name }}</div>
            </li>
          </ul>
        </div>
      </div>
      <div v-else class="content">
        <div v-if="selectedItem.type === 'ServiceCompute'">
          <div class="topic">运算对象</div>
          <el-radio-group v-model="detailType" class="radioList" @change="selectDetail">
            <el-radio label="ServiceNumCompute">
              <span>数值运算</span>
              <div class="tips">
                对两个同类型字段进行数值计算
              </div>
            </el-radio>
            <el-radio label="ServiceDateCompute">
              <span>日期运算</span>
              <div class="tips">
                对 日期/时间 添加/减去年、月、天、小时、分进行计算
              </div>
            </el-radio>
            <el-radio label="ServiceSheetCompute">
              <span>多条数据运算</span>
              <div class="tips">
                对流程中获取的多条数据进行计算
              </div>
            </el-radio>
          </el-radio-group>
        </div>
        <div v-else-if="selectedItem.type == 'ServiceNotify'">
          <div class="topic">通知类型</div>
          <el-radio-group v-model="detailType" class="radioList" @change="selectDetail">
            <el-radio label="web">
              <span>通知</span>
              <div class="tips">
                发送给个人的站内、钉钉通知
              </div>
            </el-radio>
            <el-radio label="dingGroup">
              <span>群通知</span>
              <div class="tips">
                发送给钉钉的群通知
              </div>
            </el-radio>
            <el-radio label="phone">
              <span>短信通知</span>
              <div class="tips">
                发送给指定手机号的短信通知
              </div>
            </el-radio>
            <el-radio label="emailFile">
              <span>邮件通知</span>
              <div class="tips">
                发送给指定邮箱的邮件通知
              </div>
            </el-radio>
          </el-radio-group>
        </div>
      </div>
      <select-gateway-insert-type-dialog
        ref="selectGatewayInsertTypeDialog"
        @submit="$emit('insertFlowNode', { name: '分支', type: 'Gateway' }, $event)"
      ></select-gateway-insert-type-dialog>
    </el-drawer>
  </div>
</template>

<script>
import SelectGatewayInsertTypeDialog from "./SelectGatewayInsertTypeDialog"
import {
  allWorkflowItemType,
  taskWorkflowItemType
} from "@/views/Backend/AdminEdit/Workflow/components/static"
import { findBranchEndNode } from "@/utils/workFlow"

export default {
  name: "insertNewFlowNode",
  props: {
    workflow: Object,
    drawerVisible: Boolean,
    preNode: Object,
    branchIndex: Number
  },
  components: { SelectGatewayInsertTypeDialog },
  data() {
    return {
      header: "选择一个动作",
      drawer: true,
      direction: "rtl",
      detailVisible: false,
      selectedItem: {},
      detailType: ""
    }
  },
  computed: {
    filterType() {
      if ("task" === this.workflow.type) {
        return taskWorkflowItemType
      }
      return "START_TYPE_SUB" === this.workflow.trigger?.type
        ? allWorkflowItemType.map(group => ({
            ...group,
            list: group.list.filter(item => !["SubProcess", "UserVerify"].includes(item.type))
          }))
        : allWorkflowItemType.map(group => ({
            ...group,
            list: group.list.filter(item => !["SubProcessRes"].includes(item.type))
          }))
    }
  },
  methods: {
    open() {
      //
    },
    handleClose() {
      this.$emit("update:drawerVisible", false)
    },
    closed() {
      Object.assign(this.$data, this.$options.data())
    },
    canSelectGatewayInsertType(node) {
      if (node.type !== "Gateway") return false
      let processItems = this.workflow?.dmProcess?.items || []
      let startNodeId = null
      switch (this.preNode.type) {
        case "Gateway":
          startNodeId =
            this.branchIndex !== null
              ? this.preNode.nexts[this.branchIndex]
              : processItems.find(node => node.id === this.preNode.id + "_close")?.nexts[0]
          break
        default:
          startNodeId = this.preNode.nexts[0]
      }
      let branchEndNode = findBranchEndNode(processItems, startNodeId)
      return Boolean(branchEndNode)
    },
    insertFlowNode(item) {
      if (!this.detailVisible && item.type == "ServiceCompute") {
        this.header = item.name
        this.selectedItem = item
        this.detailVisible = true
        return
      } else if (!this.detailVisible && item.type == "ServiceNotify") {
        this.header = item.name
        this.selectedItem = item
        this.detailVisible = true
        return
      } else if (this.detailVisible && this.selectedItem.type == "ServiceNotify") {
        item.dataType = item.type
        item.type = "ServiceNotify"
      }
      if (this.canSelectGatewayInsertType(item)) {
        this.$refs.selectGatewayInsertTypeDialog.open(this.moveFlag)
        return
      }
      this.$emit("insertFlowNode", item)
    },
    hideDetail() {
      this.header = "选择一个动作"
      this.detailVisible = false
    },
    selectDetail(val) {
      this.insertFlowNode({
        type: val
      })
    }
  }
}
</script>

<style lang="scss">
.drawer-insertNode {
  width: 480px;
  &:focus {
    outline: none;
  }
  .el-drawer__header {
    height: 55px;
    min-height: 55px;
    color: #fff;
    margin: 0;
    padding: 0;
  }
  .titleContianer {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 55px;
    display: flex;
    align-items: center;
    background-color: rgb(33, 150, 243);
    font-size: 18px;
    .title {
      width: 100%;
      padding: 0 20px;
      display: flex;
      .icon-back {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 5px;
        margin-right: 8px;
        cursor: pointer;
      }
    }
  }
  .el-drawer__close-btn {
    color: #fff;
    position: absolute;
    top: 0;
    right: 10px;
    height: 55px;
    outline: none;
  }
  .content {
    padding: 0 24px 15px;
    font-size: 14px;
    overflow-y: scroll;
    height: calc(100vh - 55px);
    &::-webkit-scrollbar {
      display: none;
    }
    .listTitle {
      font-size: 14px;
      color: #757575;
      padding-top: 15px;
    }
    .nodeList {
      margin: 0;
      padding: 0;
      list-style-type: none;
      display: flex;
      padding-bottom: 12px;
      flex-wrap: wrap;
      font-size: 13px;
      color: #333;
      line-height: 1.5;
      li {
        margin-right: 16px;
        margin-top: 12px;
        width: 110px;
        height: 120px;
        box-sizing: border-box;
        border: 1px solid #e8e8e8;
        border-radius: 6px;
        display: inline-flex;
        align-items: center;
        flex-direction: column;
        padding: 12px 10px 0;
        text-align: center;
        cursor: pointer;
        list-style: none;
        &:hover {
          background: #f8f8f8;
        }
        .nodeIcon {
          width: 56px;
          height: 56px;
          border-radius: 50%;
          align-items: center;
          display: flex;
          justify-content: center;
          .svg-icon,
          i {
            font-size: 32px;
            color: #fff;
          }
        }
        .nodeName {
          margin-top: 8px;
          line-height: 16px;
          font-size: 13px;
        }
      }
    }
    .topic {
      margin-top: 20px;
      font-size: 13px;
      font-weight: bold;
    }
    .radioList {
      display: flex;
      flex-direction: column;
      margin-top: 20px;
      .el-radio {
        margin-bottom: 20px;
        height: 30px;
        line-height: 30px;
        &:not(:last-child) {
          padding-bottom: 30px;
        }
        .el-radio__label {
          font-size: 16px;
          color: #000;
        }
        .tips {
          height: 30px;
          line-height: 30px;
          color: #757575;
          padding-left: 24px;
          font-size: 13px;
          // cursor: text;
          .tipsBtn {
            cursor: pointer;
            color: #1e88e5;
            &:hover {
              color: #1565c0;
            }
          }
        }
      }
    }
  }
}
</style>
